export default
function (ngModule) {
    ngModule.directive('rateDocument', ['DropdownService', function (DropdownService) {
        'use strict';

        return {
            replace: false,
            restrict: 'E',
            template: require('./rate-document.html'),
            scope: {
                rating: '=',
                documentId: '@',
                overlaySentiment: '&',
                isSentimentModified: '=',
                originalSentiment: '='
            },
            link: function (scope, element) {
                scope.toggleOptions = function toggleOptions() {
                    scope.isExpanded = !scope.isExpanded;
                    DropdownService.setCurrent({
                        id: scope.documentId,
                        element: element,
                        hide: function() {
                            scope.isExpanded = false;
                        }
                    });
                };
            },
            controller: ['$scope', function ($scope) {
                var ratingOptions = {
                    'P': {clazz: 'positiveRating', message: 'Positive'},
                    'N': {clazz: 'neutralRating', message: 'Neutral'},
                    'V': {clazz: 'negativeRating', message: 'Negative'},
                    'U': {clazz: 'noRating', message: 'Not Rated'}
                };

                $scope.model = getRating($scope.rating);
                $scope.overlayOptions = [
                    {
                        text: 'Positive',
                        value: 'P'
                    },
                    {
                        text: 'Neutral',
                        value: 'N'
                    },
                    {
                        text: 'Negative',
                        value: 'V'
                    },
                    {
                        text: 'Not Rated',
                        value: 'U'
                    }];
                $scope.isExpanded = false;

                $scope.applyOverlay = $scope.overlaySentiment();

                $scope.$watch('rating', function (ratingKey) {
                    $scope.model = getRating(ratingKey);
                });

                function getRating(key) {
                    return ratingOptions[key] || ratingOptions['U'];
                }
            }]
        };
    }]);
}


// WEBPACK FOOTER //
// ./source/components/rate-document/rate-document.js